module.exports = __webpack_public_path__ + "img/793.8877ede6.png";